import moment from 'moment-timezone'
function padTo2Digits(num) {
	return num.toString().padStart(2, '0');
}

export const formatDate = (date) => {
	
	date = toTimeZone(date,"Europe/Athens","DD/MM/YYYY HH:mm:ss");
	
	return date; 

};

export const formatDateWithFormat = (date,format) => {
	date = toTimeZone(date,"Europe/Athens",format);
	return date;

};

export const  toTimeZone = (date, zone,format) => {
	const fromFormat = "YYYY-MM-DD HH:mm:ss"

    return moment(date, fromFormat).format(format);
} 

export const  format = (date,format) => {
	const fromFormat = "YYYY-MM-DD"
    return moment(date, fromFormat).format(format);
}
